import styled from 'styled-components';
import { theme } from '../theme';

// Global styles for login page to prevent scrolling
export const LoginPageWrapper = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100vw;
  height: 100vh;
  overflow: hidden;
  z-index: 9999;
`;

export const LoginContainer = styled.div`
  height: 100vh;
  width: 100vw;
  background: linear-gradient(135deg, #fef7f0 0%, #f8f9fa 30%, #e9ecef 70%, #f1f3f4 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 2rem;
  overflow: hidden;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
`;

export const LoginCard = styled.div`
  background: #ffffff;
  border-radius: ${theme.borderRadius.xl};
  box-shadow: ${theme.shadows.heavy};
  padding: 3rem;
  width: 100%;
  max-width: 400px;
  position: relative;
  overflow: hidden;
  max-height: 90vh;
  overflow-y: auto;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 4px;
    background: linear-gradient(135deg, #FF8C42 0%, #FF5F6D 100%);
  }
`;

export const LoginHeader = styled.div`
  text-align: center;
  margin-bottom: 2rem;
`;

export const LoginTitle = styled.h1`
  font-size: 2rem;
  font-weight: 700;
  color: #212529;
  margin: 0 0 0.5rem 0;
  background: linear-gradient(135deg, #FF8C42 0%, #FF5F6D 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
`;

export const LoginSubtitle = styled.p`
  color: #6c757d;
  font-size: 1rem;
  margin: 0;
`;

export const FormContainer = styled.form`
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
`;

export const InputGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`;

export const Label = styled.label`
  font-weight: 600;
  color: #212529;
  font-size: 0.9rem;
`;

export const Input = styled.input`
  padding: 12px 16px;
  border: 2px solid #dee2e6;
  border-radius: ${theme.borderRadius.md};
  font-size: 1rem;
  transition: all ${theme.transitions.normal};
  background: #f8f9fa;

  &:focus {
    outline: none;
    border-color: ${theme.colors.primary};
    background: #ffffff;
    box-shadow: 0 0 0 3px rgba(255, 140, 66, 0.1);
  }

  &::placeholder {
    color: #adb5bd;
  }
`;

export const ErrorMessage = styled.div`
  color: ${theme.colors.error};
  font-size: 0.875rem;
  margin-top: 0.25rem;
`;

export const Divider = styled.div`
  display: flex;
  align-items: center;
  margin: 1.5rem 0;
  
  &::before,
  &::after {
    content: '';
    flex: 1;
    height: 1px;
    background: #dee2e6;
  }
  
  span {
    padding: 0 1rem;
    color: #6c757d;
    font-size: 0.875rem;
  }
`;

export const SocialLoginContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
`;

export const SocialButton = styled.button<{ $provider: 'google' | 'facebook' }>`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.75rem;
  padding: 12px 16px;
  border: 2px solid #dee2e6;
  border-radius: ${theme.borderRadius.md};
  background: #ffffff;
  color: #212529;
  font-weight: 600;
  cursor: pointer;
  transition: all ${theme.transitions.normal};
  font-size: 0.9rem;

  ${({ $provider }) => {
    switch ($provider) {
      case 'google':
        return `
          &:hover {
            border-color: #4285f4;
            color: #4285f4;
            transform: translateY(-1px);
            box-shadow: ${theme.shadows.medium};
          }
        `;
      case 'facebook':
        return `
          &:hover {
            border-color: #1877f2;
            color: #1877f2;
            transform: translateY(-1px);
            box-shadow: ${theme.shadows.medium};
          }
        `;
    }
  }}

  &:hover {
    transform: translateY(-1px);
    box-shadow: ${theme.shadows.medium};
  }
`;

export const FooterText = styled.p`
  text-align: center;
  color: #6c757d;
  font-size: 0.875rem;
  margin-top: 1.5rem;

  a {
    color: ${theme.colors.primary};
    text-decoration: none;
    font-weight: 600;

    &:hover {
      text-decoration: underline;
    }
  }
`;

export const SignUpButton = styled.button`
  background: none;
  border: none;
  color: ${theme.colors.primary};
  text-decoration: none;
  cursor: pointer;
  padding: 0;
  font: inherit;
  font-weight: 600;

  &:hover {
    text-decoration: underline;
  }
`;

export const ForgotPasswordLink = styled.a<{ $disabled?: boolean }>`
  color: ${theme.colors.primary};
  text-decoration: none;
  font-size: 0.9rem;
  cursor: ${({ $disabled }) => $disabled ? 'not-allowed' : 'pointer'};
  transition: all ${theme.transitions.normal};
  opacity: ${({ $disabled }) => $disabled ? 0.6 : 1};

  &:hover {
    text-decoration: ${({ $disabled }) => $disabled ? 'none' : 'underline'};
    color: ${({ $disabled }) => $disabled ? theme.colors.primary : theme.colors.hover.primary};
  }
`;

export const SuccessMessage = styled.div`
  color: ${theme.colors.success};
  font-size: 0.9rem;
  margin-bottom: 1rem;
  text-align: center;
`;

export const ForgotPasswordContainer = styled.div`
  text-align: center;
  margin-bottom: 1rem;
`;
